import { render, staticRenderFns } from "./ScopeForm.vue?vue&type=template&id=68e93889&scoped=true&"
import script from "./ScopeForm.vue?vue&type=script&lang=js&"
export * from "./ScopeForm.vue?vue&type=script&lang=js&"
import style0 from "./ScopeForm.vue?vue&type=style&index=0&id=68e93889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e93889",
  null
  
)

export default component.exports